import {AutoMap} from '@automapper/classes';
import {
  TBaseBulkDeleteResponseDto,
  TBaseCreateResponseDto,
  TBaseDeleteResponseDto, TBaseGetAllResponseDto, TBaseGetResponseDto, TBaseUpdateResponseDto
} from './common/t-base-response.dto';
import {
  TBaseBulkDeleteRequestDto,
  TBaseCreateRequestDto, TBaseDeleteRequestDto,
  TBaseGetAllRequestDto,
  TBaseGetRequestDto,
  TBaseUpdateRequestDto
} from './common/t-base-request.dto';
import {UserSettingReminderFrequencyTypeEnum} from '../enums/user-setting-reminder-frequencytype.enum';

export class UserSettingGetAllRequestDto extends TBaseGetAllRequestDto {}
export class UserSettingGetAllResponseDto extends TBaseGetAllResponseDto {
  @AutoMap()
  reminderIsEnabled!: boolean;

  @AutoMap()
  reminderFrequencyType!: UserSettingReminderFrequencyTypeEnum;

  @AutoMap()
  highlightsCountPerReminder!: number;

  @AutoMap()
  highlightRecency!: number;

  @AutoMap()
  preferredReminderTime!: string;

  @AutoMap()
  timeZone!: string;
}

export class UserSettingGetRequestDto extends TBaseGetRequestDto {}
export class UserSettingGetResponseDto extends TBaseGetResponseDto {
  @AutoMap()
  reminderIsEnabled!: boolean;

  @AutoMap()
  reminderFrequencyType!: UserSettingReminderFrequencyTypeEnum;

  @AutoMap()
  highlightsCountPerReminder!: number;

  @AutoMap()
  highlightRecency!: number;

  @AutoMap()
  preferredReminderTime!: string;

  @AutoMap()
  timeZone!: string;
}

export class UserSettingCreateRequestDto extends TBaseCreateRequestDto {
  @AutoMap()
  reminderIsEnabled!: boolean;

  @AutoMap()
  reminderFrequencyType!: UserSettingReminderFrequencyTypeEnum;

  @AutoMap()
  highlightsCountPerReminder!: number;

  @AutoMap()
  highlightRecency!: number;

  @AutoMap()
  preferredReminderTime!: string;

  @AutoMap()
  timeZone!: string;
}
export class UserSettingCreateResponseDto extends TBaseCreateResponseDto {}

export class UserSettingUpdateRequestDto extends TBaseUpdateRequestDto {
  @AutoMap()
  reminderIsEnabled!: boolean;

  @AutoMap()
  reminderFrequencyType!: UserSettingReminderFrequencyTypeEnum;

  @AutoMap()
  highlightsCountPerReminder!: number;

  @AutoMap()
  highlightRecency!: number;

  @AutoMap()
  preferredReminderTime!: string;

  @AutoMap()
  timeZone!: string;
}
export class UserSettingUpdateResponseDto extends TBaseUpdateResponseDto {}

export class UserSettingDeleteRequestDto extends TBaseDeleteRequestDto {}
export class UserSettingDeleteResponseDto extends TBaseDeleteResponseDto {}

export class UserSettingBulkDeleteRequestDto extends TBaseBulkDeleteRequestDto {}
export class UserSettingBulkDeleteResponseDto extends TBaseBulkDeleteResponseDto {}
